import React from 'react';
import { Icon } from 'react-icons-kit';
import Fade from 'react-reveal/Fade';
import { arrowRight } from 'react-icons-kit/feather/arrowRight';
import Heading from 'common/components/Heading';
import NextImage from 'common/components/NextImage';
import Text from 'common/components/Text';
import PropTypes from 'prop-types';
import Link from 'next/link';
import {
  ContainerBlog,
  FilterBlogContainer,
  ListBlogContainer,
} from 'containers/SaasModern/Blog/blog.style';
import { Title, BoxStyled, BoxDescription, PaginationContainer, PageButton, PageInfo, ButtonContainer } from './style';
import { format } from 'date-fns';
import { Section, Grid, Article } from '../LatestBlog/LatestBlog.style';
import { BannerWrapperNav } from 'containers/SaasModern/Banner/banner.style';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import Container from 'common/components/UI/Container';
import FilterBlogs from '../FilterBlogs';
import { useRouter } from 'next/router';
import Box from 'common/components/Box';
import { ArrowRight, ArrowLeft } from '@mui/icons-material';
import useBlogsHooks from './useBlogsHooks';
import { useTranslations } from 'hooks/useTranslations';

const AllBlogs = ({ imageStyle, data, data_main, articleTags }) => {
  const {t} = useTranslations()
  const router = useRouter();
  const { title } = router.query;
  const { 
    currentPage, 
    totalPages, 
    paginatedArticles, 
    handlePageChange 
  } = useBlogsHooks(data);

  return (
    <>
      <BannerWrapperNav />
      <BoxStyled>
        <Title>{data_main?.data?.title || 'Blog'}</Title>
        <BoxDescription>
          <PrismicRichText field={data_main?.data?.description || []} />
        </BoxDescription>
      </BoxStyled>
      <Section id="newsfeed">
        <Container width="1400px">
          <ContainerBlog>
            <FilterBlogContainer>
              <FilterBlogs
                labelCategory={data_main?.data?.category}
                labelResetFilter={data_main?.data?.reset_filter}
                placeholderInput={data_main?.data?.placeholder_input}
                listTags={articleTags}
                filter={title}
              />
            </FilterBlogContainer>
            <ListBlogContainer>
              <Grid>
                {paginatedArticles.map((article) => {
                 
                  let articleDate;
                  let formatedDate = 'No date';
                  
                  try {
                    if (article.data?.published_date) {
                      articleDate = new Date(article.data.published_date);
                      if (!isNaN(articleDate.getTime())) {
                        formatedDate = format(articleDate, 'MMM dd, yyyy');
                      } else {
                        console.warn('Invalid published_date for article:', article.data?.title || article.id);
                        formatedDate = 'Invalid date';
                      }
                    } else {
                      console.warn('No published_date found for article:', article.data?.title || article.id);
                      formatedDate = 'No date';
                    }
                  } catch (error) {
                    console.error('Error processing date for article:', article.data?.title || article.id, error);
                    formatedDate = 'Date error';
                  }
                  
                  return (
                    <Link
                      key={article.id}
                      href={`/blog/${article.uid}`}
                      style={{ textDecoration: 'none' }}
                      locale={router.locale}
                    >
                      <Fade up delay={article.id * 100}>
                        <Article>
                          <NextImage
                            style={imageStyle}
                            field={article.data?.hero_image}
                          />
                          <Text
                            style={{ color: '#000' }}
                            content={formatedDate}
                          />
                          <Heading
                            as="h3"
                            style={{ color: '#000' }}
                            content={article.data?.title || 'Untitled'}
                          />
                          <Box>
                            {'Learn more'} <Icon icon={arrowRight} />
                          </Box>
                        </Article>
                      </Fade>
                    </Link>
                  );
                })}
              </Grid>
              {totalPages > 1 && (
                <PaginationContainer>
                  <ButtonContainer>
                    {currentPage > 1 && (
                      <PageButton 
                        onClick={() => handlePageChange(currentPage - 1)}
                        aria-label="Previous Page"
                      >
                        <ArrowLeft style={{ marginRight: '5px' }} />
                        {t('pagination_blogs.Previous')}
                      </PageButton>
                    )}
                    
                    {currentPage < totalPages && (
                      <PageButton 
                        onClick={() => handlePageChange(currentPage + 1)}
                        aria-label="Next Page"
                      >
                        {t('pagination_blogs.Next')}
                        <ArrowRight style={{ marginLeft: '5px' }} />
                      </PageButton>
                    )}
                  </ButtonContainer>
                  
                  <PageInfo>
                  {t('pagination_blogs.Page')} {currentPage}  {t('pagination_blogs.of')} {totalPages}
                  </PageInfo>
                </PaginationContainer>
              )}
            </ListBlogContainer>
          </ContainerBlog>
        </Container>
      </Section>
    </>
  );
};

AllBlogs.propTypes = {
  imageStyle: PropTypes.object,
};

AllBlogs.defaultProps = {
  imageStyle: {
    width: 300,
    height: 200,
    borderRadius: '10px',
  },
};

export default AllBlogs;